var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"localPost text-14"},[_c('div',{staticClass:"image"},[_c('p',[_vm._v("Todavía no hay publicaciones")])]),_c('div',{staticClass:"infoPost"})])
}]

export { render, staticRenderFns }